import { render, staticRenderFns } from "./AllPerformances.vue?vue&type=template&id=5942ac06"
import script from "./AllPerformances.vue?vue&type=script&lang=js"
export * from "./AllPerformances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports